function ingredientCalculator (){
  const addButton = document.querySelector('.js_add-person');
  const removeButton = document.querySelector('.js_remove-person');
  
  if(!addButton || !removeButton) {return};
  
  const ingredientElements = document.querySelectorAll('.js_ingredient-amount');
  const personEl = document.querySelector('.js_persons');
  function normalizePersons(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed >= 1 ? parsed : 1;
  }

  let personAmount = normalizePersons(personEl.dataset.persons);
  let ingredients = [];
  let onePersonIngredients = [];

  // setup ingredient list 
  function setupIngredients () {
    ingredientElements.forEach(ingredient => {
      ingredients.push(Number(ingredient.dataset.amount));
    });
    onePersonIngredients = calcOnePerson(personAmount);
  }
  setupIngredients();

  function calcOnePerson (persons) {
    const safePersons = normalizePersons(persons);
    let newIngredientsForOnePerson = [];
    if(ingredients.length > 0){        
      ingredients.forEach(function(item) {
        newIngredientsForOnePerson.push(item/safePersons);        
      });      
    return newIngredientsForOnePerson;
    }
  } 

  function updateIngredientAmounts(newIngredients) {
    ingredients = newIngredients;
    ingredientElements.forEach((ingredient, index) => { 
      ingredient.innerHTML = ingredients[index];
      ingredient.dataset.amount = ingredients[index];
    });
  }

  function calcNewIngredients(persons) {
    let newList = [];
    onePersonIngredients.forEach(function(item) {
      newList.push(item * persons);      
    });
    updateIngredientAmounts(newList);
    return ingredients = newList;
  }

  function updatePersonAmount(newAmount) {
    personAmount = normalizePersons(newAmount);
    personEl.dataset.persons = personAmount; 
    personEl.innerHTML = personAmount; 
  }

  function addPerson() {
    let newAmount = personAmount += 1;        
    updatePersonAmount(newAmount);
    calcNewIngredients(newAmount);
    return newAmount;
  };

  function removePerson() {
    if(personAmount > 1) {
      let newAmount = personAmount -= 1;
      updatePersonAmount(newAmount);
      calcNewIngredients(newAmount);
      return newAmount;
    }
    else {
      return null;
    }
  };

  addButton.addEventListener('click', addPerson);
  removeButton.addEventListener('click', removePerson);
}

export default ingredientCalculator;
